// Format Units utility function (simplified version)
export const formatUnits = (value: bigint, decimals: number): string => {
  const divisor = BigInt(10 ** decimals);
  const quotient = value / divisor;
  const remainder = value % divisor;

  const formattedRemainder = remainder.toString().padStart(decimals, "0");
  return `${quotient.toString()}.${formattedRemainder}`;
};

// Helper function for formatting credit limits
export const formatAvailableLimit = (
  availableLimit: number,
  creditType: string
): number => {
  const decimals = creditType === "aave-v3" ? 6 : 18;
  const formatted = Number(formatUnits(BigInt(availableLimit), decimals));
  return Number(formatted.toFixed(4));
};

// Mapper function to convert Euler metadata to include suppliedAssets
export function mapEulerMetadataToSuppliedAssets(metadata: any) {
  if (!Array.isArray(metadata?.vaults)) return metadata;

  const suppliedAssets = metadata.vaults.map((vault: any) => {
    const formattedAsset = Number(formatUnits(BigInt(vault.assets || 0), 18));

    console.log({ formattedAsset });
    return {
      UsageAsCollateralEnabledOnUser: true, // Assume true for Euler
      amount: formattedAsset,
      amountUSD: 0, // No USD value provided, set to 0 or calculate if possible
      collateralAmountBase: String(formattedAsset),
      collateralAmountBig: formattedAsset,
      supplyRate: 0, // Not provided by Euler, set to 0 or fetch if available
      underlyingAsset: vault.vault || "",
    };
  });

  const suppliedValue = suppliedAssets.reduce(
    (sum: number, asset: any) => sum + asset.amountUSD,
    0
  );

  return {
    ...metadata,
    suppliedAssets,
    suppliedValue,
  };
}
